import { useIntl } from 'react-intl';
import { SMLUpgradeFeature } from '../../music24/config/music24PlanCapabilities';
import { planNameMessages } from '../../music24/config/music24PlanNames';
import { formatPlanPrice, useDisplayCurrency } from '../../music24/config/useDisplayCurrency';
import { useNextPlanForFeature } from '../../music24/hooks/useNextPlanForFeature';
import { useIsNativeEmbed } from '../../music24/navigation/hooks/useIsNativeEmbed';
import { fansMessages } from '../../music24/fans/fansMessages';

/**
 * The lock chip of a pre-save control on a plan with no `canUsePresave` (design presave-subscriptions
 * d2, d4, d5): "On Artist, $19 a month". A native web view quotes no web price. `null` when the
 * plan has pre-saves or no plan gives them.
 */
export function usePresaveLockLabel(): string | null {
  const intl = useIntl();
  const { current, nextPlan } = useNextPlanForFeature(SMLUpgradeFeature.presave);
  const currency = useDisplayCurrency();
  const isNativeEmbed = useIsNativeEmbed();

  if (current.canUsePresave || nextPlan === null) {
    return null;
  }
  const plan = intl.formatMessage(planNameMessages[nextPlan.tier]);
  if (isNativeEmbed) {
    return intl.formatMessage(fansMessages.lockPlanNoPrice, { plan });
  }
  return intl.formatMessage(fansMessages.lockPlan, {
    plan,
    price: formatPlanPrice(intl, nextPlan.prices.monthly.amount, currency),
  });
}
